import { path } from "ramda"
import { useSelector } from "react-redux"

const useStateGetter = <T>(keyPath: string[]) =>
  useSelector((state) => path<T>(keyPath, state))

export default useStateGetter
